<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-row justify="center">
          <picture>
            <source
              media="(max-width: 700px)"
              sizes="75vw"
              srcset="../assets/logo-bredtmann-md.png 356w, ../assets/logo-bredtmann-lg.png 506w, ../assets/logo-bredtmann-xl.png 712w"
            >
            <source
              media="(max-width: 1400px)"
              sizes="40vw"
              srcset="../assets/logo-bredtmann-md.png 356w, ../assets/logo-bredtmann-lg.png 506w, ../assets/logo-bredtmann-xl.png 712w"
            >
            <img
              src="../assets/logo-bredtmann-lg.png"
              alt="Logo Bredtmann - wundervolle Haare"
              class="my-3"
            >
          </picture>
          <!-- <img
            src="../assets/logo-bredtmann-sm.png"
            sizes="80vw"
            srcset="../assets/logo-bredtmann-md.png 356w, ../assets/logo-bredtmann-lg.png 506w, ../assets/logo-bredtmann-xl.png 712w"
            loading="lazy"
            alt="Logo Bredtmann - wundervolle Haare"
          /> -->
        </v-row>
        <v-row justify="center">
          <v-btn v-for="site in socialmedia" :key="site.icon" :href="site.link" class="mx-3" icon>
            <v-icon size="24px" color="secondary">{{ site.icon }}</v-icon>
          </v-btn>
        </v-row>
      </v-col>

      <v-col id="news"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Aktuelles
        </h2>

        <p justify="center" class="mx-3">
          <span>
            <br>
            Liebe Kunden,<br>
            <br>
            wir haben <strong>montags geschlossen</strong>.<br>
            <br>
            Ihr Friseur Bredtmann Team<br>
          </span>
        </p>
      </v-col>

      <v-col id="appointment"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Termin
        </h2>

        <p justify="center" class="mx-3">
          <span>
            Zur Terminvereinbarung erreichen Sie uns während der üblichen Öffnungszeiten telefonisch unter:<br>
            <a href="tel:023367015">02336 7015</a><br>
            <br>
            Eine Terminbuchung per E-Mail ist leider nicht möglich.<br>
          </span>
        </p>
      </v-col>

      <v-col id="openinghour"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Unsere Öffnungszeiten
        </h2>

        <v-row justify="center">
          <v-simple-table>
            <!-- <thead>
              <tr>
                <th class="text-left">Wochentag</th>
                <th class="text-left">Uhrzeiten</th>
              </tr>
            </thead> -->
            <tbody>
              <tr>
                <td>Montag</td>
                <!--<td align="right">10 - 18:30 Uhr</td>-->
                <td align="right"><strong>geschlossen</strong></td>
              </tr>
              <tr>
                <td>Dienstag - Freitag</td>
                <td align="right">9 - 18:30 Uhr</td>
              </tr>
              <tr>
                <td>Samstag</td>
                <td align="right">8 - 14:00 Uhr</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-row>
      </v-col>

      <v-col id="price"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Preise
        </h2>

        <v-row justify="center">
          <v-simple-table>
            <template v-for="(item,i) in prices">
            <thead :key=i>
              <tr>
                <th class="text-left secondary--text subtitle-1" style="font-weight:bold">{{ item.kategorie }}</th>
                <th class="text-center secondary--text subtitle-2">EUR</th>
              </tr>
            </thead>
            <tbody :key=i>
              <tr v-for="price in item.liste" :key="price.name">
                <td align="left">{{ price.name }}</td>
                <td>{{ price.preis }}<span v-if="price.lang_preis"><br><small>(lang {{ price.lang_preis }})</small></span></td>
              </tr>
            </tbody>
            </template>
          </v-simple-table>
        </v-row>
        <div class="mt-3"><small>Alle Preise inklusive 19% MwSt.</small></div>
      </v-col>
<!--
      <v-col id="product"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Produkte
        </h2>
        <v-row justify="center">
          <v-simple-table>
            <template v-for="(item,i) in products">
            <thead :key=i>
              <tr>
                <th class="text-left secondary--text subtitle-1" style="font-weight:bold">{{ item.kategorie }}</th>
                <th class="text-left secondary--text subtitle-2">Menge</th>
                <th class="text-center secondary--text subtitle-2">EUR</th>
              </tr>
            </thead>
            <tbody :key=i>
              <template v-for="price in item.liste">
              <tr v-if="price.name == ''" :key=price.name class="listentry--empty"><td></td><td></td><td></td></tr>
              <tr v-else :key=price.name>
                <td align="left">{{ price.name }}</td>
                <td align="left">{{ price.menge }}</td>
                <td>{{ price.preis }}</td>
              </tr>
              </template>
            </tbody>
            </template>
          </v-simple-table>
        </v-row>
        <div class="mt-3"><small>Alle Preise inklusive 19% MwSt.</small></div>
      </v-col>
-->
      <v-col id="impressum"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Impressum
        </h2>

        <v-row justify="center" class="my-5">
          Onofria GmbH<br/>
          Hauptstr. 67<br/>
          58332 Schwelm
        </v-row>
        <v-row justify="center" class="my-5">
          Telefon: 02336 7015<br/>
          E-Mail: {{ mail }}
        </v-row>
        <v-row justify="center" class="my-5">
          Geschäftsführerin: Onofria Bredtmann<br/>
          Registernummer: HRB 7542 (Amtsgericht Hagen)<br/>
          U.St. ID-Nr. DE252135303
        </v-row>
        <v-row justify="center" class="my-5">
          <a color="secondary--text" href="/datenschutz.html">Datenschutzerklärung gemäß DS-GVO</a>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.listentry--empty td
{
  height: 15px;
}
</style>

<script>
  function decode(value) {
    return value.replace('*', '@').replace(/~/g, '.').split("").reverse().join("");
  }

  export default {
    name: 'HelloWorld',

    data: () => ({
      mail: decode('ed.nnamtderb-ruesirf*ofni'),
      socialmedia: 
        [
          {
            link: 'https://www.facebook.com/pg/bredtmann.schwelm',
            icon: 'mdi-facebook'
          },
          {
            link: 'https://www.instagram.com/bredtmann/',
            icon: 'mdi-instagram'
          }
        ],
      prices: [
        {
          kategorie: 'Damen',
          liste: [{
            name:  'Waschen, schneiden, föhnen (kurze Haare)',
            preis: 'ab 57,-',
          },
          {
            name:  'Waschen, schneiden, föhnen (lange Haare)',
            preis: 'ab 60,-',
          },
          {
            name:  'Waschen, schneiden, selber föhnen (kurze Haare)',
            preis: 'ab 42,-',
          },
          {
            name:  'Waschen, schneiden, selber föhnen (lange Haare)',
            preis: 'ab 45,-',
          },
          {
            name:  'Waschen, föhnen (kurze Haare)',
            preis: 'ab 27,-',
          },
          {
            name:  'Waschen, föhnen (lange Haare)',
            preis: 'ab 30,-',
          }]
        },
        {
          kategorie: 'Damen Studierende',
          liste: [{
            name:  'Waschen, schneiden, föhnen Studierende (kurze Haare)',
            preis: 'ab 50,-',
          },
          {
            name:  'Waschen, schneiden, föhnen Studierende (lange Haare)',
            preis: 'ab 53,-',
          },
          {
            name:  'Waschen, schneiden, selber föhnen Studierende (kurze Haare)',
            preis: 'ab 38,-',
          },
          {
            name:  'Waschen, schneiden, selber föhnen Studierende (lange Haare)',
            preis: 'ab 40,-',
          }]
        },
        {
          kategorie: 'Färben & Tönen',
          liste: [{
            name:  'Färben',
            preis: 'ab 40,-',
          },
          {
            name:  'Neufärbung (kurze Haare)',
            preis: 'ab 55,-',
          },
          {
            name:  'Neufärbung (lange Haare)',
            preis: 'ab 60,-',
          },
          {
            name:  'Abmattierung',
            preis: 'ab 20,-',
          }]
        },
        {
          kategorie: 'Strähnen',
          liste: [{
            name:  'Foliensträhnen kurz',
            preis: 'ab 45,-',
          },
          {
            name:  'Foliensträhnen mittel',
            preis: 'ab 65,-',
          },
          {
            name:  'Foliensträhnen lang',
            preis: 'ab 85,-',
          },
          {
            name:  'Painting',
            preis: 'ab 55,-',
          },
          {
            name:  'Balayage (nur mit Termin und 50,- € Anzahlung)',
            preis: 'ab 150,-',
          },
          {
            name:  'Balayage (extra lange oder dicke Haare)',
            preis: 'ab 180,-',
          }]
        },
        {
          kategorie: 'Dauerwelle',
          liste: [{
            name:  'Dauerwelle Komplettparket (kurze Haare)',
            preis: 'ab 100,-',
          },
          {
            name:  'Dauerwelle Komplettparket (lange Haare)',
            preis: 'ab 120,-',
          }]
        },
        {
          kategorie: 'Pflege',
          liste: [{
            name:  'Maske/ Kur',
            preis: '10,-',
          },
          {
            name:  'Schnellkur (wird nicht abgespült)',
            preis: '5,-',
          },
          {
            name:  'Mangala Gloss (kurze Haare)',
            preis: '15,-',
          },
          {
            name:  'Mangala Gloss (lange Haare)',
            preis: '20,-',
          }]
        },
        {
          kategorie: 'Kosmetik',
          liste: [{
            name:  'Augenbrauen zupfen',
            preis: '7-10',
          },
          {
            name:  'Wimpern färben',
            preis: '15,-',
          },
          {
            name:  'Augenbrauen färben',
            preis: '10,-',
          },
          {
            name:  'Komplettparket (Wimpern & Augenbrauen färben & zupfen)',
            preis: '25,-',
          },
          {
            name:  'Fadentechnik Augenbrauen',
            preis: 'ab 10,-',
          },
          {
            name:  'Fadentechnik Gesicht',
            preis: 'ab 20,-',
          }]
        },
        {
          kategorie: 'Herren',
          liste: [{
            name:  'Waschen, schneiden, stylen',
            preis: 'ab 27,-',
          },
          {
            name:  'Waschen, schneiden, stylen Studierende',
            preis: 'ab 25,-',
          },
          {
            name:  'Färben',
            preis: 'ab 35,',
          }]
        },
        {
          kategorie: 'Kinder & Schüler*innen',
          liste: [{
            name:  'Waschen, schneiden, stylen bis 5 Jahre',
            preis: '10-15',
          },
          {
            name:  'Waschen, schneiden, stylen von 5 bis 12 Jahre',
            preis: 'ab 22,-',
          },
          {
            name:  'Waschen, schneiden, stylen ab 12 Jahre',
            preis: 'ab 25,-',
          },
          {
            name:  'Waschen, schneiden, stylen (extra lange oder dicke Haare)',
            preis: 'ab 30,-',
          }]
        },
      ]
    }),
    

  methods: {
    getImage() {
      console.log(this.$vuetify.breakpoint)
      return require('../assets/logo-bredtmann-' + this.$vuetify.breakpoint.name + '.png');
    }
  }
  }
</script>
